import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,oklch(var(--primary-400)/0.6),transparent_60%)]" />
          <div className="relative">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-background-50 md:text-3xl">
              {t("cta.title")}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
              {t("cta.body")}
            </p>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              {t("cta.button")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}